export default defineNuxtPlugin(() => {
  // SPA mode doesn't inject __NUXT_SITE_CONFIG__, so set the site name on client.
  updateSiteConfig({
    name: "Rozay",
    url: "https://rozay.today",
    description:
      "Pakistan ke liye sehri aur iftar ke waqti maloomat - seedhi, saaf aur bharosemand.",
    defaultLocale: "ur-PK",
  });
});
